// src/components/layout/Layout.tsx
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { UitlegPanel } from "../components/ui/UitlegPanel";

export default function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(1200));
  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar fixed on the left */}
      <Sidebar />

      {/* Page content on the right */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "background.neutral",
          color: "text.primary",
          px: isMobile ? 2 : "36px",
          pb: isMobile ? 2 : "18px",
          pt: isMobile ? 10 : "28px",
          height: "100dvh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>

      {/* Per-screen "Uitleg" help FAB + side panel (on all authenticated screens) */}
      <UitlegPanel />
    </Box>
  );
}
